exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-notification[data-v-2d1a4d94]{margin-left:0}.select-style[data-v-2d1a4d94] .ui.selection.dropdown .menu{max-height:150px}.custom-input[data-v-2d1a4d94]{margin-right:-5px;padding-top:5px;padding-bottom:5px}.oneIntakeCheckBoxCountries[data-v-2d1a4d94]{margin-right:4px}", ""]);

// exports
